module.exports = __webpack_public_path__ + "img/spins_6.5.83f4ed63.png";